import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import TaxService from "services/TaxService";
export const initialState = {
  data: [],
  dataDetail: [],
  loading: false,
  error: null,
  redirect: false,
};

export const fetchTaxData = createAsyncThunk(
  "tax/fetchTaxData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await TaxService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchTaxDetail = createAsyncThunk(
  "tax/fetchTaxDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await TaxService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createTaxData = createAsyncThunk(
  "tax/createTaxData",
  async (data, { rejectWithValue }) => {
    try {
      const { name, value } = data;
      const response = await TaxService.createTax({
        name,
        value,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateTaxData = createAsyncThunk(
  "tax/updateTaxData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, name, value } = data;
      const response = await TaxService.updateTax({
        id,
        name,
        value,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteTaxData = createAsyncThunk(
  "tax/deleteTaxData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await TaxService.deleteTax(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const taxSlice = createSlice({
  name: "tax",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaxData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(fetchTaxData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchTaxData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTaxDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTaxDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchTaxDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTaxData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createTaxData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createTaxData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTaxData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTaxData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateTaxData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTaxData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteTaxData.fulfilled, (state) => {
        state.loading = false;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deleteTaxData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading } = taxSlice.actions;

export default taxSlice.reducer;
